import { FC } from 'react';
import { Badge, Typography } from '../../../ui';
import { Divider } from '../../../atoms/divider/divider';
import { StatusIconStylesVariants } from '../../../atoms/statusIcon/variants';

type Props = {
  color: StatusIconStylesVariants['color'];
  variant: StatusIconStylesVariants['variant'];
  status: string;
  date: string;
};

export const ChangedPriorityDivider: FC<Props> = (props) => {
  const { color, variant, status, date } = props;

  return (
    <Divider>
      <div className="flex items-center space-x-8">
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400 text-nowrap"
        >
          Prioriteit veranderd naar
        </Typography>
        <Badge status={{ color, variant }} label={status} />
        <Typography
          variant="body-xxs"
          weight="regular"
          className="text-grayscale300 text-nowrap"
        >
          {date}
        </Typography>
      </div>
    </Divider>
  );
};
